import { Typography, TypographyProps } from "@mui/material";
import React, { ReactNode } from "react";

type TOwnProps = TypographyProps & {
  children: ReactNode;
};

const SubHeading = (props: TOwnProps) => {
  const { children, ...rest } = props;
  return <Typography variant="h4">{children}</Typography>;
};

export default SubHeading;
